export var name = 'hints';
